var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('span',{domProps:{"textContent":_vm._s(_vm.state.label)}}):_c('v-chip',{attrs:{"color":_vm.state.color,"text-color":_vm.state.textColor,"small":_vm.small},domProps:{"textContent":_vm._s(_vm.state.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }